/** @jsx jsx */

import { Alert } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';
import { useDismissable } from 'app/developer-v3/hooks';

const PERSIST_ID = 'developer-dashboard-news';

function NewsBar() {
  const { dismiss, isVisible } = useDismissable({ persistId: PERSIST_ID });

  return (
    isVisible && (
      <Alert
        layout="banner"
        onDismiss={dismiss}
        title="Welcome to the Zapier Platform UI!"
        type="info"
      >
        Now it’s easier than ever to get started with a Zapier integration.{' '}
        <Link
          href={`${BASE_DOC_URL_VB}/quickstart/how-zapier-works`}
          target="_blank"
        >
          Learn more
        </Link>
        .
      </Alert>
    )
  );
}

export default NewsBar;
